<template>
  <div
    class="aside_wrapper"
    :style="{ paddingBottom: showFooter ? '50px' : null }"
  >
    <!-- <p class="aside_title">{{ title }}</p> -->
    <div class="aside_search">
      <el-input
        placeholder="测风塔编号"
        class="input-with-select"
        size="small"
        v-model="searchParam"
        @keyup.enter.native="search"
      >
        <i
          class="el-input__icon el-icon-search"
          slot="suffix"
          @click.enter="search"
        ></i>
      </el-input>
    </div>
    <el-menu
      :default-active="defaultIndex"
      ref="menu"
      background-color="#32323AFF"
      :class="{
        'menu_wrapper-y': showChildren,
        'menu_wrapper-no': !showChildren
      }"
    >
      <template v-if="filteredMenu.length">
        <template v-if="!showChildren">
          <el-menu-item
            :key="items.towerCode"
            v-for="items in filteredMenu"
            @click="e => doClickMenu(items, {})"
            :index="items.towerId + ''"
            class="menu_custom_item"
            :class="'key' + '-' + items.towerId"
          >
            <span>{{ items.towerCode }}</span>
            <i
              v-if="items.ifUpdate == 1 && moduleType === 'towerList'"
              class="el-icon-delete"
              @click="deleteTower(items.towerId)"
            ></i>
          </el-menu-item>
        </template>
        <el-submenu
          v-for="items in filteredMenu"
          :key="items.towerCode"
          :index="items.towerId + ''"
          v-else
        >
          <template slot="title">{{ items.towerCode }}</template>
          <el-menu-item
            v-for="subItem in items.towerVersionList"
            :key="subItem.versionId + ''"
            :index="items.towerId + '-' + subItem.versionId"
            @click="doClickMenu(items, subItem)"
            :class="'key' + '-' + items.towerId + '-' + subItem.versionId"
          >
            <div class="menu_item_sub">
              <span>{{ subItem.versionName }}</span>
              <menu-btn
                :state="subItem.state"
                :is-owner-flag="subItem.isOwnerFlag"
                :original="subItem.original"
                :version-name="subItem.versionName"
                @refresh="refreshMenu"
                :version-id="subItem.versionId"
                :tower-id="items.towerId"
                :menu="filteredMenu"
                ref="menuBtn"
                :module-type="moduleType"
              >
              </menu-btn>
            </div>
          </el-menu-item>
        </el-submenu>
      </template>
      <div v-else class="empty_text">
        暂无数据
      </div>
    </el-menu>
    <left-menu-footer v-if="showFooter" :tower-list="menu"></left-menu-footer>
  </div>
</template>

<script>
import menuBtn from './menu-btn';
import leftMenuFooter from './left-menu-footer';
import cloneDeep from 'lodash/cloneDeep';
const fetchUrl = {
  towerList: '/winddata/tower/getTowerList',
  dataProcess: '/winddata/dataProcess/getDataProcessMenu',
  analysis: '/winddata/dataProcess/getDataProcessMenu'
};
export default {
  props: {
    title: {
      type: String
    },
    passData: {
      type: Function,
      default: function() {}
    },
    clickMenu: {
      type: Function,
      default: function() {}
    },
    showChildren: {
      type: Boolean,
      default: true
    },
    showMenu: {
      type: Boolean,
      default: false
    },
    moduleType: {
      type: String,
      default: 'dataProcess'
    },
    showFooter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchParam: '',
      menu: [],
      defaultIndex: '',
      showBtn: false,
      fetchUrl,
      filteredMenu: []
    };
  },
  computed: {
    modifyStatus() {
      return this.$store.state.WindData.modifyStatus;
    }
  },
  watch: {
    modifyStatus() {
      this.getMenuList();
    }
  },
  async created() {
    await this.getMenuList();
    this.getDefaultIndex();
  },

  methods: {
    search() {
      if (!this.searchParam) {
        this.filteredMenu = cloneDeep(this.menu);
      }
      let arr = this.menu.filter(
        item =>
          item.towerCode && item.towerCode.indexOf(this.searchParam) !== -1
      );
      this.filteredMenu = arr;
      if (arr.length) {
        let first = arr[0];
        this.getDefaultIndex(first, true);
      }
    },
    doClickMenu(parent, subItem = {}) {
      let res = parent.towerId;
      if (this.showChildren) {
        res += '-' + subItem.versionId;
      }
      sessionStorage.setItem('selectMenu', res);
      let resData = { ...parent, ...subItem };
      if (resData.towerVersionList) {
        delete resData.towerVersionList;
      }
      if (this.showMenu) {
        this.getContentMenuList(resData);
      }
      this.deafultIndex = res;
      this.$store.commit('WindData/SET_IDSTRING', res);
      this.$store.commit('WindData/SET_TOWER_INFO', resData);
      //console.log(resData);
    },
    async getMenuList(keyword) {
      let res = await this.$fetch(this.fetchUrl[this.moduleType], {
        module: 'windData',
        params: {
          keyword
        }
      });
      if (res.code == 0) {
        let data = res.data;
        let menu = this.moduleType === 'towerList' ? data.towerList : data.menu;
        this.menu = menu;
        this.filteredMenu = cloneDeep(this.menu);
      }
    },
    getDefaultIndex(menuItem, isSearch) {
      if (!this.menu.length) return;
      this.defaultIndex = '';
      let selectMenu = sessionStorage.getItem('selectMenu');
      let res = null;
      let resData = null;
      if (selectMenu && !isSearch) {
        let towerId = selectMenu.split('-')[0];
        let versionId = selectMenu.split('-')[1];
        let item = this.menu.find(v => v.towerId == towerId);
        let subItem = {};
        if (this.moduleType !== 'towerList') {
          subItem = item.towerVersionList.find(v => v.versionId == versionId);
        }
        if (!versionId && this.moduleType !== 'towerList') {
          subItem = item.towerVersionList[0];
          versionId = subItem.versionId;
        }
        if (!this.showChildren) {
          res = towerId;
        } else {
          res = towerId + '-' + versionId;
        }
        resData = { ...item, ...subItem };
      } else {
        let firstItem = menuItem || this.menu[0];
        let towerId = firstItem.towerId;
        let towerVersionList = [];
        let versionId = '';
        if (this.moduleType !== 'towerList') {
          towerVersionList = firstItem.towerVersionList;
          versionId = towerVersionList[0].versionId;
        }
        res = towerId + '-' + versionId;
        if (!this.showChildren) {
          res = towerId;
        }
        resData = { ...firstItem, ...towerVersionList[0] };
      }
      this.defaultIndex = res;
      if (resData.towerVersionList) {
        delete resData.towerVersionList;
      }
      // 给defaultIndex 赋值， 页面菜单默认不高亮， 暂时没找到问题， js解决
      if (menuItem) {
        this.$nextTick(() => {
          let _item = document.querySelector(`.key-${res}`);
          _item.classList.add('is-active');
          _item.click();
        });
      }
      if (this.showMenu) {
        this.getContentMenuList(resData);
      }
      this.$store.commit('WindData/SET_TOWER_INFO', resData);
      this.$store.commit('WindData/SET_IDSTRING', res);
    },
    getContentMenuList(obj) {
      let { original, isOwnerFlag } = obj || {};
      //console.log(original, isOwnerFlag);
      let menuList = [
        {
          name: '完整性分析',
          path: '/wind-data/data-process/integrity-analysis'
        },
        {
          name: '合理性检验',
          path: '/wind-data/data-process/rationality-verification'
        },
        {
          name: '插补延长',
          path: '/wind-data/data-process/interpolation-extension'
        },
        {
          path: '/wind-data/data-process/year-revision',
          name: '代表年订正'
        }
      ];
      let menus = [];
      if (!original && isOwnerFlag) {
        menus = menuList;
      } else {
        menus = menuList.slice(0, 1);
      }
      // menus = menuList;
      this.$store.commit('WindData/SET_MENU', menus);
      if (!menus.find(v => v.path === this.$route.path)) {
        this.$router.push(menus[0].path);
      }
    },
    async refreshMenu(data) {
      await this.getMenuList();
      let { towerId } = data || {};
      if (towerId) {
        let item = this.menu.find(item => item.towerId === towerId);
        if (item) {
          this.$nextTick(() => {
            this.getDefaultIndex(item);
          });
        }
      }
    },
    async deleteTower(towerId) {
      this.$confirm('是否确认删除测风塔？', '删除测风塔', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        cancelButtonClass: 'ct-btn-default',
        confirmButtonClass: 'ct-btn-primary',
        closeOnClickModal: false
      }).then(() => {
        this.$postForm('/winddata/tower/delTowerMenu', {
          module: 'windData',
          showLoading: true,
          showError: true,
          data: {
            towerIds: towerId
          }
        }).then(() => {
          let _this = this;
          async function redict() {
            await _this.getMenuList();
            let item = _this.menu[0];
            _this.defaultIndex = item.towerId;
            _this.$store.commit('WindData/SET_TOWER_INFO', item);
            _this.$store.commit('WindData/SET_IDSTRING', item.towerId);
          }
          redict();
        });
      });
    }
  },
  components: {
    menuBtn,
    leftMenuFooter
  }
};
</script>

<style lang="less">
.aside_wrapper {
  .el-menu {
    border-right: none !important;
  }
  .empty_text {
    color: #999;
    line-height: 60px;
    text-align: center;
  }
  .menu_item_sub {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    padding: 0 10px 0 30px;
    color: #98989c;
  }
  .menu_custom_item {
    position: relative;
    display: flex;
    align-items: center;

    i {
      font-size: 14px;
      position: absolute;
      right: 10px;
    }
  }
  // 没有子菜单样式
  .menu_wrapper-no {
    .el-menu-item {
      height: 34px;
      line-height: 34px;
      color: #fff;
      padding: 0 20px;
      font-size: 14px;
      &.is-active {
        background-color: #015cad !important;
        color: #fff !important;
      }
    }
  }
  .el-menu-item,
  .el-submenu__title {
    &:hover {
      background-color: #50535cff !important;
    }
  }
  // 有子菜单
  .menu_wrapper-y {
    .el-submenu {
      color: #98989c !important;
    }
    .el-menu-item {
      padding: 0 !important;
      color: #98989c !important;
      font-size: 14px;
      height: 41px;
      line-height: 41px;
      &.is-active {
        .menu_item_sub {
          // background: #0056aa;
          background-color: #015cad !important;
          color: #fff;
        }
      }
    }
    .el-submenu__title {
      // padding: 0 20px 0 10px !important;
      font-size: 16px;
      color: #98989b !important;
      // font-weight: bold;
      height: 41px;
      line-height: 41px;
    }
  }
}
</style>
